import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const FolderTree = ({ folders, selectedFolder, onFolderSelect, onCreateFolder }) => {
  const [expandedFolders, setExpandedFolders] = useState(new Set(['root']));

  const toggleFolder = (folderId) => {
    const newExpanded = new Set(expandedFolders);
    if (newExpanded?.has(folderId)) {
      newExpanded?.delete(folderId);
    } else {
      newExpanded?.add(folderId);
    }
    setExpandedFolders(newExpanded);
  };

  const renderFolder = (folder, level = 0) => {
    const isExpanded = expandedFolders?.has(folder?.id);
    const isSelected = selectedFolder?.id === folder?.id;
    const hasChildren = folder?.children && folder?.children?.length > 0;

    return (
      <div key={folder?.id} className="select-none">
        <div
          className={`flex items-center py-2 px-3 rounded-lg cursor-pointer transition-smooth hover:bg-muted ${
            isSelected ? 'bg-primary text-primary-foreground' : 'text-foreground'
          }`}
          style={{ paddingLeft: `${12 + level * 16}px` }}
          onClick={() => onFolderSelect(folder)}
        >
          {hasChildren && (
            <Button
              variant="ghost"
              size="icon"
              className="w-4 h-4 p-0 mr-1"
              onClick={(e) => {
                e?.stopPropagation();
                toggleFolder(folder?.id);
              }}
            >
              <Icon
                name={isExpanded ? "ChevronDown" : "ChevronRight"}
                size={12}
                className={isSelected ? 'text-primary-foreground' : 'text-muted-foreground'}
              />
            </Button>
          )}
          
          <Icon
            name={folder?.type === 'department' ? 'Building2' : 'Folder'}
            size={16}
            className={`mr-2 ${isSelected ? 'text-primary-foreground' : 'text-muted-foreground'}`}
          />
          
          <span className="flex-1 text-sm font-medium truncate">{folder?.name}</span>
          
          {folder?.itemCount > 0 && (
            <span className={`text-xs px-2 py-1 rounded-full ${
              isSelected 
                ? 'bg-primary-foreground text-primary' 
                : 'bg-muted text-muted-foreground'
            }`}>
              {folder?.itemCount}
            </span>
          )}
        </div>
        {hasChildren && isExpanded && (
          <div>
            {folder?.children?.map(child => renderFolder(child, level + 1))}
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="h-full flex flex-col bg-card border-r border-border">
      <div className="p-4 border-b border-border">
        <div className="flex items-center justify-between mb-3">
          <h2 className="text-lg font-semibold text-foreground">Vaults</h2>
          <Button
            variant="ghost"
            size="icon"
            onClick={onCreateFolder}
            className="w-8 h-8"
          >
            <Icon name="Plus" size={16} />
          </Button>
        </div>
        
        <div className="relative">
          <Icon
            name="Search"
            size={16}
            className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground"
          />
          <input
            type="text"
            placeholder="Search vaults..."
            className="w-full pl-9 pr-3 py-2 text-sm bg-muted border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-ring"
          />
        </div>
      </div>
      <div className="flex-1 overflow-y-auto p-2">
        {folders?.map(folder => renderFolder(folder))}
      </div>
    </div>
  );
};

export default FolderTree;